import { TemplateRef } from '@angular/core';

/*
 * @Author: Liux
 * @Date: 2020-01-02 06:31:00
 * @LastEditor: Liux
 * @LastEditTime: 2020-05-20 14:31:41
 */
export class AdAlertConfig {
  /**
   * To set this alert overlay an offset of the border. Default is zero.
   */
  borderOffset? = 0;

  /**
   * Set a left offset. Require unit. In fact is margin-left.
   * This value will overwrite the right value.
   */
  left? = '';

  /**
   * Set a top offset. Require unit. In fact is margin-top.
   * This value will overwrite the bottom value.
   */
  top? = '20px';

  /**
   * Set a right offset. Require unit. In fact is margin-right.
   * If the left has value, this value will not work.
   */
  right? = '';

  /**
   * Set a bottom offset. Require unit. In fact is margin-bottom.
   * If the top has value, this value will not work.
   */
  bottom? = '';

  verticalCenter? = false;
  horizontalCenter? = true;

  /**
   * To set a value that can controls this overlay can automatically close itself or never close itself.
   * If set a number value that will automatically close this overlay itself after this milliseconds time past.
   * If set to false, it means never close itself.
   * If set to true, will automaticall close this overlay after 5000 milliseconds time past.
   */
  autoClose?: boolean | number = 5000;

  showAction? = false;
  contentTemplate?: TemplateRef<any>;
  actionTemplate?: TemplateRef<any>;
  type?: 'info' | 'error' | 'warning' | 'successful' = 'info';

  /**
   * If set true, can open multiple alert messages, otherwise only open an alert message in same time.
   * Default is false.
   */
  multiple? = false;
}
